import React from 'react';

const LightingSwitch = ({ viewGLRef, setLightingType }) => {
  const handleLightingChange = (type) => {
    setLightingType(type); //void lightingType
    if (viewGLRef.current) {
      viewGLRef.current.updateSceneLighting(type);
    }
  };

  return (
    <div style={{ position: 'absolute', fontSize: "8px", top: '29px', left: '10px', zIndex: 1000 }}>
      <label>
        <input
          type="radio"
          name="lightingType"
          value="addLightV5"
          defaultChecked
          onChange={e => handleLightingChange(e.target.value)}
        />
        1
      </label>
      <label>
        <input
          type="radio"
          name="lightingType"
          value="addLightV4"
          onChange={e => handleLightingChange(e.target.value)}
        />
        2
      </label>
      {/*<label>*/}
      {/*  <input*/}
      {/*    type="radio"*/}
      {/*    name="lightingType"*/}
      {/*    value="addLightV6"*/}
      {/*    onChange={e => handleLightingChange(e.target.value)}*/}
      {/*  />*/}
      {/*  3*/}
      {/*</label>*/}
      {/*<label>*/}
      {/*  <input*/}
      {/*    type="radio"*/}
      {/*    name="lightingType"*/}
      {/*    value="addLightV7"*/}
      {/*    onChange={e => handleLightingChange(e.target.value)}*/}
      {/*  />*/}
      {/*  4*/}
      {/*</label>*/}
      {/* Добавьте дополнительные радиокнопки для новых методов освещения здесь */}
    </div>
  );
};

export default LightingSwitch;
